import { Enum } from '~/data/enums';

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export enum AbsenceStatus {
  DRAFT = 'DRAFT',
  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  PROPOSED = 'PROPOSED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum AbsenceSupersededReason {
  DELETE = 'DELETE',
  EDIT = 'EDIT',
}

export enum AbsenceType {
  SHORT = 'SHORT',
  LONG = 'LONG',
}

export type AttachmentInfo = {
  id: number;
  name: string;
  type?: string;
  isArchived?: boolean;
};

type AbsenceEntryCommon = {
  id: number | undefined;
  uid: string | undefined;
  reason: Enum;
  status: AbsenceStatus;
  startDate: Date;
  attachment: AttachmentInfo;
  info?: string;
  deciderEmpId?: number;
  deciderName?: string;
  decidedDate?: Date;
  empId?: number;
  enteredUserName?: string;
  enteredTime?: Date;
  supersededName?: string;
  supersededReason?: string;
  supersededDate?: Date;
};

export type ShortAbsenceEntry = AbsenceEntryCommon & {
  endDate: Date;
  year?: number;
  type: AbsenceType.SHORT;
  days?: number | undefined;
  hours?: number | undefined;
  plannedWorkingHours?: number | undefined;
};

export type LongAbsenceEntry = AbsenceEntryCommon & {
  type: AbsenceType.LONG;
  endDate?: Date | undefined;
};

export type NewAbsenceEntry<T extends AbsenceEntryCommon> = PartialBy<
  T,
  'reason' | 'startDate' | 'attachment'
> & {
  status: AbsenceStatus.DRAFT;
};

export type AbsenceEntry =
  | NewAbsenceEntry<ShortAbsenceEntry>
  | NewAbsenceEntry<LongAbsenceEntry>
  | ShortAbsenceEntry
  | LongAbsenceEntry;

export type AbsenceHistory<T> = T & { history: T[] };
